import type { AuthUser } from '@mexp/shared';

/** Staff pages live under /internal; the client portal owns the root paths. */
export const INTERNAL = '/internal';

/** A staff page path, e.g. staff('/requests') → '/internal/requests'. */
export function staff(path = '/'): string {
  return path === '/' ? INTERNAL : `${INTERNAL}${path}`;
}

/** Where each kind of user starts. */
export function homeFor(user: Pick<AuthUser, 'userType'> | null | undefined): string {
  return user?.userType === 'exporter' ? '/' : INTERNAL;
}

/** Where each kind of user signs in. */
export function loginFor(user: Pick<AuthUser, 'userType'> | null | undefined): string {
  return user?.userType === 'exporter' ? '/login' : `${INTERNAL}/login`;
}

/** Only same-site paths are followed after sign-in (never `//host` or absolute URLs). */
export function safeNext(value: string | null, fallback: string): string {
  return value && value.startsWith('/') && !value.startsWith('//') ? value : fallback;
}
